import { useState, useEffect, useRef } from 'react';
import {
    makeStyles,
    Box,
    Typography,
    Container,
    Grid,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
} from '@material-ui/core';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';

// layout
import HomeLayout from '/layouts/HomeLayout';

// components
import Slider from '/components/shared/Slider';
import ScrollBox from '/components/shared/ScrollBox';
import ProjectItem from '/components/modules/ProjectItem';
import NewsCard from '/components/cards/NewsCard';
import NewsCardNew from '/components/cards/NewsCardNew';
import DocItem from '/components/modules/DocItem';
import JobItem from '/components/modules/JobItem';
import TextAnimate from '/components/shared/TextAnimate';

// actions
import { getAll } from '/context/actions/projects';
import { getDocs } from '/context/actions/docs';
import { getJobs } from '/context/actions/jobs';
import { getSliders } from '/context/actions/slider';
import { getVoteList, answerVote } from '/context/actions/vote';
import { getNews } from '/context/actions/news';

const useStyles = makeStyles(() => ({
    root: {},
    projets: {
        paddingTop: 25,
        width: '100%',
    },
    docs: {
        marginTop: 30,
        marginBottom: 30,
    },
    news: {
        paddingTop: 25,
        justifyContent: 'center',
        display: 'grid',
    },
    projetsBG: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        borderRadius: 6,
    },
    arrowIcn: {
        margin: 20,
        opacity: 0.2,
    },
    teamsScrollBoxWrapper: {
        width: '100%',
        height: 220,
        marginTop: 8,
        marginBottom: 10,
    },
    teamImageBox: {
        width: 187,
        height: 220,
        overflow: 'hidden',
        marginRight: 14,
        cursor: 'pointer',
    },
    banner: {
        borderRadius: 6,
    },
    bannerBttn: {
        backgroundColor: 'whitesmoke',
        padding: '7px 30px',
        margin: 5,
    },
    bannerBttnchosed: {
        backgroundColor: 'red',
        padding: '7px 30px',
        margin: 5,
        color: 'white',
    },
    bttnMenu: {
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
    },
    bttnLine: {
        backgroundColor: '#c9c9c9',
        height: 2,
        width: 321,
        borderRadius: 1,
    },
    bannerList: {
        backgroundColor: 'whitesmoke',
        padding: 20,
        borderRadius: 6,
        marginTop: 10,
    },
    docTitle: {
        fontSize: 16,
        minWidth: 'fit-content',
    },
    docLine: {
        height: 1,
        backgroundColor: '#e9e9e9',
        width: '100%',
        fontSize: 16,
        marginLeft: 5,
    },
    votes: {
        borderRadius: 6,
        marginTop: 10,
    },
    voteImge: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: 6,
        marginTop: 10,
        marginRight: 7,
    },
    voteBox: {
        backgroundColor: 'whitesmoke',
    },
    voteLine: {
        width: '100%',
        height: 1,
        marginTop: 8,
        marginBottom: 15,
        backgroundColor: '#3C4A3E',
    },
    voteAlertIcon: {
        alignItems: 'center',
    },
    voteQuestion: {
        fontSize: 14,
        lineHeight: 1.4,
        marginBottom: 8,
    },
    voteSendButton: {
        width: '100%',
        marginTop: 24,
        color: '#fff',
        backgroundColor: '#1e93f0',
        borderRadius: 6,
    },
}));

export default function IndexPage({ projects, sliders, votes, docs1, docs2, jobs, videos }) {
    const classes = useStyles();
    // const { state } = useContext(GlobalContext);
    const router = useRouter();
    const [news, setNews] = useState(null);
    const [voteAlert, setVoteAlert] = useState({
        show: false,
        message: '',
        severity: '',
    });
    const voteAnswer = useRef();
    const [isAnswered, setIsAnswered] = useState(false);
    const selectedVote = votes[0];

    const sorted = selectedVote.answers.sort((a, b) => {
        return a.id - b.id;
    });

    useEffect(() => {
        getNews('?limit=5&noVideo=1').then((result) => {
            setNews(result.list);
        });
    }, []);

    const handleClickNewsItem = (id) => {
        router.push('/news/' + id);
    };

    const handleClickNewsNewItem = (id) => {
        router.push('/video/' + id);
    };

    const handleVote = async () => {
        if (voteAnswer.current) {
            const isAnswer = Cookies.get('vote_answer');
            if (isAnswer) {
                setIsAnswered(true);

                setVoteAlert({
                    show: true,
                    message: 'Нэг хаягнаас цагт нэг санал өгнө!',
                    severity: 'warning',
                });
            } else {
                Cookies.set('vote_answer', true, { expires: 1 / 24 });
                await answerVote(voteAnswer.current);

                selectedVote.answers.forEach((answer) => {
                    if (answer.id + '' === voteAnswer.current) {
                        answer.count++;
                        selectedVote.totalCount++;
                    }
                });

                setIsAnswered(true);

                setVoteAlert({
                    show: true,
                    message: 'Санал өгсөнд баярлалаа!',
                    severity: 'success',
                });
            }
        } else {
            setVoteAlert({
                show: true,
                message: 'Саналаа сонгоно уу!',
                severity: 'warning',
            });
        }
    };

    const handleAlertClose = () => {
        setVoteAlert({
            show: false,
            message: '',
            severity: '',
        });
    };

    return (
        <Container className={classes.root} maxWidth="lg">
            {news && (
                <>
                    <Box className={classes.news}>
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Typography
                                style={{ fontSize: 18, minWidth: 'fit-content' }}
                                variant="subtitle1"
                            >
                                Мэдээ мэдээлэл
                            </Typography>
                            <Box className={classes.docLine}></Box>
                            <Button
                                onClick={() => {
                                    router.push('news');
                                }}
                                style={{ color: '#0078f6', minWidth: 'fit-content' }}
                            >
                                Бусад мэдээ
                            </Button>
                        </Box>
                        <Grid container spacing={1}>
                            <Grid item lg={6} md={12} sm={12}>
                                {news[0] && (
                                    <NewsCard
                                        size="lg"
                                        data={news[0]}
                                        onClick={() => handleClickNewsItem(news[0].id)}
                                    />
                                )}
                            </Grid>
                            <Grid item lg={6} md={12} sm={12} xs={12}>
                                <Grid container spacing={1}>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        {news[1] && (
                                            <NewsCard
                                                size="md"
                                                data={news[1]}
                                                onClick={() => handleClickNewsItem(news[1].id)}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        {news[2] && (
                                            <NewsCard
                                                size="md"
                                                data={news[2]}
                                                onClick={() => handleClickNewsItem(news[2].id)}
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1}>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        {news[3] && (
                                            <NewsCard
                                                size="md"
                                                data={news[3]}
                                                onClick={() => handleClickNewsItem(news[3].id)}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        {news[4] && (
                                            <NewsCard
                                                size="md"
                                                data={news[4]}
                                                onClick={() => handleClickNewsItem(news[4].id)}
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                    <Box
                        style={{
                            backgroundColor: 'whitesmoke',
                            minHeight: 54,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            marginTop: 20,
                            cursor: 'pointer',
                            borderRadius: 6,
                        }}
                    >
                        <Box
                            style={{
                                backgroundColor: '#91cfff',
                                height: '100%',
                                minHeight: 34,
                                minWidth: 120,
                                marginRight: 10,
                                marginLeft: 10,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 4,
                            }}
                        >
                            <Typography
                                variant="body2"
                                style={{
                                    color: '#0670c6',
                                    fontWeight: 'bold',
                                    fontSize: 13,
                                }}
                            >
                                Товч мэдээ
                            </Typography>
                        </Box>
                        <Box
                            style={{
                                overflow: 'hidden',
                                paddingTop: 3,
                                paddingBottom: 3,
                            }}
                        >
                            <TextAnimate paragraphs={news} onClick={handleClickNewsItem} />
                        </Box>
                    </Box>
                </>
            )}
            <Box>
                <Box
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: 20,
                        marginBottom: 10,
                    }}
                >
                    <Typography variant="subtitle1" className={classes.docTitle}>
                        Видео мэдээ
                    </Typography>
                    <Box className={classes.docLine}></Box>
                    <Button
                        style={{ color: '#0078f6' }}
                        onClick={() => {
                            router.push('video');
                        }}
                    >
                        Бусад
                    </Button>
                </Box>
                <Box>
                    <Grid container spacing={1}>
                        {videos &&
                            videos.list.map((video, ind) => {
                                return (
                                    <Grid item lg={3} sm={12} md={6} xs={12} key={ind}>
                                        <NewsCardNew
                                            // size="md"
                                            data={video}
                                            onClick={() => handleClickNewsNewItem(video.id)}
                                        />
                                    </Grid>
                                );
                            })}
                    </Grid>
                </Box>
            </Box>
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: 40,
                    marginBottom: 0,
                }}
            >
                <Typography variant="subtitle1" className={classes.docTitle}>
                    Төсөл хөтөлбөрүүд
                </Typography>
                <Box className={classes.docLine}></Box>
            </Box>
            <Box className={classes.projets}>
                <Box className={classes.teamsScrollBoxWrapper}>
                    <ScrollBox childWidth={154}>
                        {projects.list.length &&
                            projects.list.map((project) => {
                                return (
                                    <Box key={project.id} className={classes.teamImageBox}>
                                        <ProjectItem {...project} key={project.id} />
                                    </Box>
                                );
                            })}
                    </ScrollBox>
                </Box>
            </Box>
            <Grid className={classes.docs} container spacing={1}>
                <Grid item lg={6}>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="subtitle1" className={classes.docTitle}>
                            ИТХ-ын тогтоол
                        </Typography>
                        <Box className={classes.docLine}></Box>
                        <Button
                            onClick={() => {
                                router.push('docs?cat=2');
                            }}
                            style={{ color: '#0078f6' }}
                        >
                            Бусад
                        </Button>
                    </Box>
                    <Box className={classes.bannerList}>
                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                            {docs2 &&
                                docs2.list.map((project) => {
                                    return <DocItem {...project} key={project.id} />;
                                })}
                        </Box>
                    </Box>
                </Grid>
                <Grid item lg={6}>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="subtitle1" className={classes.docTitle}>
                            Засаг даргын захирамж
                        </Typography>
                        <Box className={classes.docLine}></Box>
                        <Button
                            style={{ color: '#0078f6' }}
                            onClick={() => {
                                router.push('docs?cat=1');
                            }}
                        >
                            Бусад
                        </Button>
                    </Box>
                    <Box className={classes.bannerList}>
                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                            {docs1 &&
                                docs1.list.map((project) => {
                                    return <DocItem {...project} key={project.id} />;
                                })}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Box className={classes.banner}>
                <Slider style={{ borderRadius: 6 }} images={sliders.list} height={130} />
            </Box>
            <Grid className={classes.docs} container spacing={1}>
                <Grid item lg={6}>
                    {selectedVote && (
                        <>
                            <Box style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="subtitle1" className={classes.docTitle}>
                                    Санал асуулга
                                </Typography>
                            </Box>
                            <Box style={{ display: 'flex' }}>
                                <Grid
                                    lg={6}
                                    className={classes.voteImge}
                                    style={{
                                        backgroundImage: `url(${selectedVote.image_path})`,
                                    }}
                                ></Grid>
                                <Grid lg={6} className={classes.bannerList}>
                                    <Box className={classes.voteBox}>
                                        <Typography
                                            variant="subtitle1"
                                            className={classes.voteQuestion}
                                        >
                                            {selectedVote.question}
                                        </Typography>
                                        <RadioGroup
                                            aria-label="position"
                                            name="position"
                                            defaultValue="top"
                                            onChange={(e) => (voteAnswer.current = e.target.value)}
                                        >
                                            {selectedVote.answers.map((answer) => (
                                                <FormControlLabel
                                                    value={answer.id + ''}
                                                    control={
                                                        <Radio
                                                            size="small"
                                                            className={classes.voteButton}
                                                            color="success"
                                                        />
                                                    }
                                                    className={classes.voteButtonRoot}
                                                    label={`${answer.answer}${
                                                        isAnswered
                                                            ? ` (${
                                                                  answer.count > 0
                                                                      ? Math.round(
                                                                            (answer.count /
                                                                                selectedVote.totalCount) *
                                                                                100
                                                                        )
                                                                      : 0
                                                              }%)`
                                                            : ''
                                                    }`}
                                                    key={answer.id}
                                                />
                                            ))}
                                        </RadioGroup>
                                        <Button
                                            variant="contained"
                                            className={classes.voteSendButton}
                                            onClick={handleVote}
                                        >
                                            Санал илгээх
                                        </Button>
                                    </Box>
                                </Grid>
                            </Box>
                        </>
                    )}
                </Grid>
                <Grid item lg={6}>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="subtitle1" className={classes.docTitle}>
                            Нээлттэй ажлын байр
                        </Typography>
                        <Button
                            style={{ color: '#0078f6' }}
                            onClick={() => {
                                router.push('jobs');
                            }}
                        >
                            Бусад
                        </Button>
                    </Box>
                    <Box className={classes.bannerList}>
                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                            {jobs &&
                                jobs.list.map((project) => {
                                    return <JobItem {...project} key={project.id} />;
                                })}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
}

export async function getServerSideProps() {
    const projects = await getAll('?limit=5');
    const sliders = await getSliders('?page=1&limit=3');
    const votes = await getVoteList();
    const docs1 = await getDocs('?menu=1');
    const docs2 = await getDocs('?menu=2');
    const jobs = await getJobs('?limit=8');
    const videos = await getNews('?limit=4&video=1');

    return {
        props: { projects, sliders, votes, docs1, docs2, jobs, videos }, // will be passed to the page component as props
    };
}

IndexPage.Layout = HomeLayout;
